module.exports = __webpack_public_path__ + "media/dogs/dog-pushing-shopping-cart-68732bb6.svg";